<template>
  <v-card>
    <v-card-title>
      <span class="headline">Add Announcement Form</span>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
    
          <v-col cols="6" sm="12" md="6">
            <date-picker :dateTimeStamp="date" />
          </v-col>
          <v-col cols="6" sm="12" md="6">
            <v-select
              v-model="select"
              :items="items"
              :rules="[(v) => !!v || 'Item is required']"
              label="Type"
              required
            ></v-select>
          </v-col>

          <v-col cols="12" sm="12" md="12">
            <v-text-field
              v-model="reference"
              label="Reference link"
              hint="Enter the full url for reference"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <v-text-field
              v-model="source"
              label="Source"
              hint="Announcement made by"
              persistent-hint
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <v-textarea
              v-model="body"
              name="input-7-1"
              label="Body of the Announcement"
              value=""
              hint="Write the entire Announcement"
            ></v-textarea>
            <v-textarea
              v-model="body1"
              name="input-7-1"
              label="ادخل البيانات بالعربي"
              value=""
              hint="البيانات بالعربي"
            ></v-textarea>
            <v-textarea
              v-model="body2"
              name="input-7-1"
              label="የማስታወቂያው አካል"
              value=""
              hint="ማስታወቂያውን በሙሉ ይፃፉ"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-container>
      <small>*indicates required field</small>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="this.triggerCloseDialog">
        Close
      </v-btn>
      <v-btn
        v-if="isUpdate === false"
        color="blue darken-1"
        text
        @click="saveAnnouncement"
      >
        Save
      </v-btn>
      <v-btn
        v-if="isUpdate"
        color="blue darken-1"
        text
        @click="editAnnouncement"
      >
        Update
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import moment from "moment";
import { mapFields } from "vuex-map-fields";
import { mapActions } from "vuex";
import { eventBus } from "@/main.js";
import datePicker from "../shared/components/datePicker";
export default {
  async created() {
    eventBus.$on("formChangeEvent", (value) => {
      if (value) {
        this.populateAnnouncementForm();
      }
    });
  },
  components: { datePicker },
  computed: {
    ...mapFields("shared", [
      "isUpdate",
      "formPopulator",
      "selectedTime",
      "selectedDate",
      "selectedDateTime",
    ]),
  },
  data: () => ({
    body: "",
    body1: "",
    body2: "",
    date: null,
    time: null,
    type: 0,
    source: "",
    reference: "",
    select: "",
    items: ["Info", "Warning"],
  }),
  methods: {
    ...mapActions("announcement", ["addAnnouncement", "updateAnnouncement"]),
    ...mapActions("shared", ["setImagePath", "dateTimeSelected"]),
    triggerCloseDialog(value) {
      eventBus.$emit("dialogToggle", false);
    },
    populateAnnouncementForm() {
      // if new form set initial states
      if (this.isUpdate === false) {
        this.date = 0;
        this.time = 0;
        this.select = null;
        this.body = "";
        this.body1 = "";
        this.body2 = "";
        this.source = "";
      } else {
        this.date = moment(this.formPopulator.date).unix();
        this.time = moment(this.formPopulator.date).unix();
        this.select = this.items[this.formPopulator.type];
        this.body = this.formPopulator.body;
        this.body1 = this.formPopulator.body1;
        this.body2 = this.formPopulator.body2;
        this.source = this.formPopulator.source;
        this.imagePath = this.formPopulator.image;
      }
    },
    async saveAnnouncement() {
      // Parse string TimeDate as TimeStamp
      var dateTime = this.selectedDate + " " + this.selectedTime;
 
 
      // set type of Announcement
      if (this.select === "Warning") {
        this.type = 1;
      } else {
        this.type = 0;
      }
      var AnnouncementContent = {
        date: moment(dateTime).format('LLL') + " UTC+3",
        body: this.body,
        body1: this.body1,
        body2: this.body2,
        source: this.source,
        type: this.type,
        reference: this.reference
      };
      
      try {
        this.addAnnouncement({
          payload: {
            announcement: AnnouncementContent,
          },
        });
        eventBus.$emit("dialogToggle", false);
        alert("Successfully Created announcement!");
      } catch (error) {
        alert("Failed to created announcement!");
      }
    },
    async editAnnouncement(form) {
      var path;
      // Parse string TimeDate as TimeStamp
      var dateTime = this.selectedDate + " " + this.selectedTime;

      // set type of Announcement
      if (this.select === "Warning") {
        this.type = 1;
      } else {
        this.type = 0;
      }
      var AnnouncementContent = {
        date: moment(dateTime).format('LLL') + " UTC+3",
        body: this.body,
        body1: this.body1,
        body2: this.body2,
        source: this.source,
        type: this.type,
      };
      try {
        this.updateAnnouncement({
          payload: {
            announcement: AnnouncementContent,
          },
          payloadId: this.formPopulator.id,
        });
        eventBus.$emit("dialogToggle", false);
        alert("Successfully Updated Announcement!");
      } catch (error) {
        alert("Failed to update Announcement!");
      }
    },
  },
};
</script>